import { render, staticRenderFns } from "./DisplayList.vue?vue&type=template&id=b2797eae&scoped=true"
import script from "./DisplayList.vue?vue&type=script&lang=js"
export * from "./DisplayList.vue?vue&type=script&lang=js"
import style0 from "./DisplayList.vue?vue&type=style&index=0&id=b2797eae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2797eae",
  null
  
)

export default component.exports